export default __webpack_public_path__ + "static/screeny-130-gpz-unica-m-scheda-tecnica-d194b44c2b35e3d674d5782b8e27f239.pdf";